import api, { fetchV2 } from "@/services/Api";
import { getGeocode } from "use-places-autocomplete";

export const getAddressByPostalCode = async (postalCode) => {
  // This pattern match is to solve the problem with US ZIP+4
  const normalizedPostalCode = postalCode.match(/^\d{5}-\d{4}$/)
    ? postalCode.slice(0, 5)
    : postalCode;
  return getGeocode({ address: `postal_code:${normalizedPostalCode}` })
    .then((res) => {
      const address_components = res?.[0]?.address_components;
      const getField = (field) => address_components.find((term) => term.types.includes(field));
      const city =
        getField("locality")?.long_name || getField("administrative_area_level_2")?.long_name || "";
      const state = getField("administrative_area_level_1")?.short_name || "";
      const country = getField("country")?.short_name;
      const zip = getField("postal_code")?.long_name;
      if (!country) throw new Error("Invalid postal code");
      return {
        country,
        postal_code: zip,
        city,
        state,
      };
    })
    .catch((err) => {
      if (err.message) throw err;
      throw new Error("Invalid postal code");
    });
};

export const getCountriesList = async () => {
  const resp = await fetchV2("/countries/");

  const countries = resp.map((country) => ({
    value: country.id,
    label: country.name,
  }));

  return countries;
};

export const getCountryStatesList = async (countryAbbr) => {
  const resp = await fetchV2(`/countries/states/${countryAbbr}`);

  const states = resp.map((country) => ({
    value: country.abbr,
    label: country.name,
  }));

  return states;
};

export const getShippingQuotesList = async ({
  city,
  company,
  country,
  email,
  name,
  phone,
  postal_code,
  state,
  street1,
  street2,
}) => {
  const resp = await api.post("/v2/store/samples/shipping_quotes", {
    city,
    company,
    country,
    email,
    name: name,
    phone,
    postal_code,
    state,
    street1,
    ...(!!street2 && { street2 }),
  });

  const shippingQuotes = resp.data.map(({ carrier, delivery_days, id, rate, service }) => ({
    rate_id: id,
    total: rate,
    service,
    provider: carrier,
    value: id,
    deliveryDays: delivery_days,
    label: `${carrier} - ${service} - $${rate}`,
  }));

  return shippingQuotes;
};

export const purchaseSample = async ({
  city,
  company,
  state,
  country,
  email,
  name,
  phone,
  postal_code,
  provider,
  rate_id,
  service,
  street1,
  token,
  total,
}) => {
  const resp = await api.post("/v2/store/samples/", {
    city,
    company,
    state,
    country,
    email,
    name,
    phone,
    postal_code,
    provider,
    rate_id,
    service,
    street1,
    token,
    total,
  });

  return resp.data;
};
